<template>
  <Icon>
    <svg slot="svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <defs>
        <path d="M19.762963,5.34248366 L12.0592593,3 C12,3 11.9407407,3 11.8814815,3 L4.17777778,5.34248366 C4.05925926,5.40104575 4,5.51816993 4,5.63529412 L4,13.6583007 C4,16.8792157 9.15555556,19.7487582 11.9407407,20.5686275 C11.9407407,20.5686275 12,20.5686275 12,20.5686275 C12,20.5686275 12.0592593,20.5686275 12.0592593,20.5686275 C14.8444444,19.7487582 20,16.8792157 20,13.6583007 L20,5.63529412 C20,5.51816993 19.9407407,5.40104575 19.762963,5.34248366 Z" id="path-1-shield-blocking"></path>
      </defs>
      <g id="icons/blokowanie" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <rect id="Bounding-Box" x="0" y="0" width="24" height="24"></rect>
        <mask id="mask-2-shield-blocking" fill="white">
          <use xlink:href="#path-1-shield-blocking"></use>
        </mask>
        <use id="Combined-Shape" fill="#43CEA2" fill-rule="nonzero" xlink:href="#path-1-shield-blocking"></use>
        <path d="M8.81802076,8.06802448 C7.06066194,9.82536538 7.06066194,12.6746166 8.81802439,14.4319791 C10.5753652,16.189338 13.4246163,16.189338 15.1819788,14.4319755 C16.9393376,12.6746346 16.9393376,9.82538338 15.181977,8.06802267 C13.4246343,6.31066196 10.5753832,6.31066196 8.81802076,8.06802448 Z M15.8890853,15.1390853 C13.741199,17.2869716 10.258779,17.2869716 8.1109147,15.1390853 C5.96302843,12.991199 5.96302843,9.50877881 8.1109147,7.36091451 C10.258801,5.2130282 13.741221,5.2130282 15.8890871,7.36091632 C18.0369716,9.50880081 18.0369716,12.991221 15.8890853,15.1390853 Z M9.24595124,15.4182622 L7.83173768,14.0040486 L14.8549049,6.98088144 L16.2691184,8.39509501 L9.24595124,15.4182622 Z" id="Combined-Shape" fill="#FFFFFF" fill-rule="nonzero" mask="url(#mask-2-shield-blocking)"></path>
      </g>
    </svg>
  </Icon>
</template>

<script>
import Icon from "./icon";

export default {
  name: 'DsShieldBlockingIcon',
  components: {
    Icon
  }
};
</script>


// WEBPACK FOOTER //
// ../panel-theme/src/js/icons/ds-shield-blocking-icon.vue